import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976D2', // Blue for buttons and highlights
    },
    background: {
      default: '#F5F5F5', // Light background
    },
    qualification: {
      seniorMets: '#EF9A9A', // Red for Senior Mets
      juniorMets: '#A5D6A7', // Green for Junior Mets
      fastest: '#90CAF9', // Light blue for fastest non-qualifying
    },
  },
  typography: {
    h1: { fontSize: '1.5rem', fontWeight: 'bold' },
    h2: { fontSize: '1.25rem', fontWeight: 'bold' },
    body1: { fontSize: '1rem' },
  },
});

export default theme;